export default __webpack_public_path__ + "static/media/down_arrow.c6bb2eac.svg";